import React from 'react';
import { Zap, Clock, Shield, TrendingUp } from 'lucide-react';
import { kiosks } from '../data/mockData';

const About = () => {
  const highlights = [
    {
      icon: Zap,
      title: 'Instant & Effortless',
      description: 'No apps, no accounts. Just scan and print in seconds.'
    },
    {
      icon: Clock,
      title: 'Time-Saving',
      description: 'Skip the queues. Print on demand or schedule for later.'
    },
    {
      icon: Shield,
      title: 'Secure & Reliable',
      description: 'Encrypted payments and secure document handling.'
    },
    {
      icon: TrendingUp,
      title: 'Smart Automation',
      description: 'AI-powered system for optimal print quality and efficiency.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Images */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <img 
                  src={kiosks.images[1]} 
                  alt="PRINTLEY Kiosk Interface" 
                  className="w-full rounded-2xl shadow-lg hover:shadow-2xl transition-shadow duration-300"
                />
              </div>
              <div className="space-y-4 pt-8">
                <img 
                  src={kiosks.images[2]} 
                  alt="PRINTLEY Kiosk in Location" 
                  className="w-full rounded-2xl shadow-lg hover:shadow-2xl transition-shadow duration-300"
                />
              </div>
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-8 -right-8 w-48 h-48 bg-yellow-200/40 rounded-full blur-3xl -z-10"></div>
          </div>

          {/* Right - Content */}
          <div className="space-y-8">
            <div>
              <span className="text-yellow-500 font-semibold text-sm uppercase tracking-wide">About PRINTLEY</span>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-3 mb-6">
                Revolutionizing Campus & Office Printing
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                PRINTLEY is a cutting-edge self-service printing solution designed for the modern world. 
                Whether you're a student rushing between classes or a professional preparing for a meeting, 
                PRINTLEY makes printing effortless.
              </p>
            </div>

            <div className="space-y-6">
              {highlights.map((item, index) => (
                <div 
                  key={index} 
                  className="flex gap-4 p-4 rounded-xl hover:bg-yellow-50 transition-colors duration-200 group"
                >
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center group-hover:bg-yellow-200 transition-colors duration-200">
                      <item.icon className="w-6 h-6 text-yellow-600" />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-1">{item.title}</h3>
                    <p className="text-gray-600">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="pt-4">
              <div className="grid grid-cols-3 gap-6">
                <div className="text-center p-4 bg-gray-50 rounded-xl">
                  <p className="text-3xl font-bold text-gray-900">28+</p>
                  <p className="text-sm text-gray-600 mt-1">Active Kiosks</p>
                </div>
                <div className="text-center p-4 bg-gray-50 rounded-xl">
                  <p className="text-3xl font-bold text-gray-900">15K+</p>
                  <p className="text-sm text-gray-600 mt-1">Daily Prints</p>
                </div>
                <div className="text-center p-4 bg-gray-50 rounded-xl">
                  <p className="text-3xl font-bold text-gray-900">99.9%</p>
                  <p className="text-sm text-gray-600 mt-1">Uptime</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
